import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25160adf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show" }

import { computed, shallowRef } from 'vue';
import { CustomFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { windows } from '@/components/common/window/Windows';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';
import { app } from '@/models/App';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceTableField',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const value = computed(() => {
  if (props.data.devices.list.length === 0) {
    return '-';
  } else if (props.data.devices.list.length <= 3) {
    return props.data.devices.list.map((i: any) => i.name).join(';');
  } else {
    return (
      props.data.devices.list
        .slice(0, 3)
        .map((i: any) => i.name)
        .join(';') + `查看更多(${props.data.devices.count})`
    );
  }
});

async function open() {
  const id = windows.open({
    content: {
      type: 'component',
      component: shallowRef(HasMany),
      props: {
        propName: 'devices',
        info: {
          title: '绑定设备',
          status: 'edit',
        },
        widget: app.data.widgetMap.management.proxy.widgets.devices.type,
        data: props.data,
      },
    },
    title: '绑定设备详情',
    width: 1280,
    height: 800,
    padding: 20,
  });
  if (await windows.getCloseData(id)) {
    props.widget.extra?.refresh();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ScBtn, {
      type: "link",
      text: value.value,
      handler: open
    }, null, 8, ["text"])
  ]))
}
}

})